aptis.virtualReality.engine.VRUserTrackingController = new Class({

	/**
	 * @var {Number|Null}
	 */
	_worldId: null,

	/**
	 * @var {String|Null}
	 */
	_trackingUrl: null,

	/**
	 * @var {Boolean}
	 */
	_enableIntercom: false,

	/**
	 * @var {String|Null}
	 */
	_temporaryTrackingSessionString: null,

	/**
	 * @var {Null|aptis.RestCommunicator}
	 */
	_restCommunicator: null,

	/**
	 * @param {Number} worldId
	 * @param {String} worldName
	 * @param {String} trackingUrl
	 * @param {Boolean} enableIntercom
	 */
	initController: function(worldId, worldName, trackingUrl, enableIntercom) {
		const me = this;

		this._worldId = worldId;
		this._trackingUrl = trackingUrl;
		this._temporaryTrackingSessionString = new aptis.UUIDGenerator().generate();
		this._restCommunicator = new aptis.RestCommunicator('');

		if (enableIntercom) {
			window.intercomSettings = {
				app_id: 'yxfw96u9', //APTIS Solutions
				vr: true,
			};
			(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/wcug0wbi';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
		}

		//TODO i18n

		this._logEvent('startWorld', 'world', null, 'Starte "' + worldName + '"');

		let bodyElement = $j('body');
		bodyElement.on('aptisSceneChanged', function(event, newScene) {
			me._logEvent('changeToScene', 'sceneChange', newScene.getId(), 'Wechselt zur Szene: ' + newScene.getPublicName());
		});

		bodyElement.on('aptisTrackingObjectCompleted', function(event, object) {
			//Single Choice / Scenen wechsel werden mit anderen Events schon eingetragen
			if (object.getType() !== 'singleChoice' && object.getType() !== 'sceneChange') {
				me._logEvent('objectCompleted', object.getType(), object.getId(), 'Objekt wurde abgeschlossen: ' + object.getName());
			}
		});

		bodyElement.on('aptisQuizAnswered', function(event, correct, answer, singleChoice) {
			if (correct) {
				me._logEvent('quizAnswered', 'singleChoice', singleChoice.getId(), 'Quiz "' + singleChoice.getQuestion() + '" wurde richtig mit "' + answer.text + '" beantwortet');
			} else {
				me._logEvent('quizAnswered', 'singleChoice', singleChoice.getId(), 'Quiz "' + singleChoice.getQuestion() + '" wurde falsch mit "' + answer.text + '" beantwortet');
			}
		});

		bodyElement.on('aptisWebLinkOpened', function(event, object) {
			me._logEvent('webLinkOpened', 'webLink', object.getId(), 'Weblink wurde geöffnet: ' + object.getUrl());
		});
	},

	/**
	 * @param {String} action
	 * @param {String} itemType
	 * @param {String} itemId
	 * @param {String} text
	 * @private
	 */
	_logEvent: function(action, itemType, itemId = null, text = '') {
		const data = {
			'sessionString': this._temporaryTrackingSessionString,
			'TrackingLogItem': {
				'worldId': this._worldId,
				'itemId': itemId,
				'itemType': itemType,
				'action': action,
				'text': text,
			}
		};

		console.log('VRUserTrackingController _logEvent post: ', data);

		this._restCommunicator.postRequest(this._trackingUrl, data, function(error, result) {
			if (error && window.console) {
				console.error('POST-Response: ', error);
			}
		});

		if (this._enableIntercom) {
			Intercom('trackEvent', action, data.TrackingLogItem);
		}
	},
});
